import type { ReactNode } from 'react';
import { ToastProvider } from '@/design-system';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { AuthProvider } from './AuthProvider';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <QueryProvider>
          <ToastProvider>
            <AuthProvider>{children}</AuthProvider>
          </ToastProvider>
        </QueryProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
